import React from "react";
import SuperUserHomePageUI from "../../../templates/SuperUserHomePageUI.js";
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI.js";
import CardUI from "../../../widgets/layout/CardUI.js";
import SwitchUI from "../../../widgets/action/SwitchUI.js";
import { Link } from "react-router-dom";
import MappingListSF from "../../../components/superUser/loan/util/MappingListSF.js";

const LendersReportPageUI = ({ context, errorList, lendersReportList, onDownloadLendersReport, onRefreshClick, response,
  checked, checkedAccount, onShowDetailsChange, onShowAccountDetailsChange, onTypeChange
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_disb_mon' topnav='accounts'
    headerText='Lenders Report' centered={!errorList} dimension='w1000' page='lenders'
    onTypeChange={onTypeChange}
  >
    {
      !errorList &&
      <SpinnerComponentUI />
    }
    {
      lendersReportList &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
            <IconButtonUI icon='icon-download' onClick={onDownloadLendersReport} label='Download' />
            {/* <span className='g_m_left_100 g_large'><b>Security Report, {response.yearMonth.monthName} {response.yearMonth.year}</b></span> */}
            <span className='g_m_left_100 g_large'><b>Lender's Report</b></span>
          </span>
        }
        right={
          <span className="g_flex_h">
            <span className='g_muted g_small g_m_right_50 g_m_left_50'>
              Show Accounts
            </span>
            <SwitchUI checked={checkedAccount} onChange={onShowAccountDetailsChange} />
            <span className='g_muted g_small g_m_right_50 g_m_left_50'>
              Show Loans
            </span>
            <SwitchUI checked={checked} onChange={onShowDetailsChange} />
            {/* <Link to={`/su/security/${response.yearMonth.prevYear}/${response.yearMonth.prevMonth}`}>Previous</Link>
            <span className='g_m_left_100' />
            <Link to={`/su/security/${response.yearMonth.nextYear}/${response.yearMonth.nextMonth}`}>Next</Link> */}
          </span>
        }
      />
    }
    {
      lendersReportList &&
      <LendersReportUI
        context={context}
        lendersReportList={lendersReportList}
        response={response}
        checked={checked}
        checkedAccount={checkedAccount}
        onRefreshClick={onRefreshClick}
      />
    }
  </SuperUserHomePageUI>

const LendersReportUI = ({ context, lendersReportList, response, checked, checkedAccount, onRefreshClick }) =>
  <div>
    <CardUI title='Lenders Report' className='g_m_top_100'>
      <table className="g_small">
        <tbody>
          <tr>
            <th>S no.</th>
            <th>Account/Loan</th>
            {
              checked &&
              <th>LRN Number</th>
            }
            <th>O/S loan</th>
            <th>Contribution By Client</th>
            <th>DSRA</th>
            <th>Current DSRA</th>
            <th>Security Deposit</th>
            <th>Hyp Lender</th>
          </tr>
          {
            checkedAccount && lendersReportList.map((lender, i) =>
              <>
                {
                  <tr className='acc' key={i}>
                    <td className='left'>{i + 1}.</td>
                    <td className='left g_no_wrap_2'>{lender.accountName}</td>
                    {
                      checked && checkedAccount &&
                      <td />
                    }
                    <td>{lender.outstandingLoanF4}</td>
                    <td style={{ textAlign: 'center' }}>{lender.dsraFromLoan ? 'No' : 'Yes'}</td>
                    <td>{lender.dsraAmountF4}</td>
                    <td>{lender.dsraCurrentF4}</td>
                    <td>{lender.securityAmountF4}</td>
                    <td><b>{lender.accountLender ? lender.accountLender : 'NA'}</b></td>
                  </tr>
                }
                {
                  checked && checkedAccount &&
                  lender.loanDTOList.map((loan, j) =>
                    <>
                      <tr className='acc' key={j}>
                        <td className='left'>{i + 1}.{j + 1}.</td>
                        <td className='left g_no_wrap_2'>{loan.loanName}</td>
                        <td>{loan.loanReferenceNumber}</td>
                        <td>{loan.outstandingLoan}</td>
                        <td style={{ textAlign: 'center' }}>{loan.dsraFromLoan ? 'No' : 'Yes'}</td>
                        <td>{loan.dsraAmount}</td>
                        <td>{loan.dsraCurrent}</td>
                        <td>{loan.securityAmount}</td>
                        <td>{loan.fundSource ? loan.fundSource : 'NA'}</td>
                      </tr>
                    </>
                  )
                }
              </>
            )
          }
          {
            !checkedAccount && checked && flattenLoanList(lendersReportList).map((loan, j) =>
              <tr className='acc' key={j}>
                <td className='left'>{j + 1}.</td>
                <td className='left g_no_wrap_2'>{loan.loanName}</td>
                <td>{loan.loanReferenceNumber}</td>
                <td>{loan.outstandingLoan}</td>
                <td style={{ textAlign: 'center' }}>{loan.dsraFromLoan ? 'No' : 'Yes'}</td>
                <td>{loan.dsraAmount}</td>
                <td>{loan.dsraCurrent}</td>
                <td>{loan.securityAmount}</td>
                <td>{loan.fundSource ? loan.fundSource : 'NA'}</td>
              </tr>
            )
          }
          <tr className='acc'>
            <td><b>Totals</b></td>
            <td />
            {
              checked &&
              <td />
            }
            <td><b>{response.totalOutStandingLoan}</b></td>
            <td />
            <td><b>{response.totalDsraAmount}</b></td>
            <td><b>{response.totalDsraCurrent}</b></td>
            <td><b>{response.totalSecurityAmount}</b></td>
            <td />
          </tr>
        </tbody>
      </table>
      <MappingListSF
        context={context}
        onRefreshClick={onRefreshClick}
        category='fund_source'
        flag={true}
        totalOutStandingLoan={response.totalOutStandingLoan}
        totalSecurityAmount={response.totalSecurityAmount}
        totalDsraCurrent={response.totalDsraCurrent}
      />
    </CardUI>
  </div>

function formatLrnNumbers(loanDTOList) {
  let formattedLrnList = "";
  for (let i = 0; i < loanDTOList.length; i++) {
    formattedLrnList += loanDTOList[i].loanReferenceNumber + ", ";
  }
  return formattedLrnList;
}

function flattenLoanList(lendersAccountList) {
  const allLoans = [];

  lendersAccountList.forEach(lender => {
    lender.loanDTOList.forEach(loan => {
      allLoans.push(loan);
    });
  });

  return allLoans;
}

export default LendersReportPageUI;